'use strict';

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Stepper from 'react-stepper-horizontal';
import { Navbar, Nav, Container, Button, Dropdown, Row, Col, CardGroup, CardDeck, Card } from 'react-bootstrap';
import CustomHeader from '../components/Header'

import "../css/Managehssestyle.css";
// import Stepper from 'react-stepper-wizard'
import VehicleGroupBox from "../components/VehicleGroupBox";
import VehicleGroupBoxItem from "../components/VehicleGroupBoxItem";
// import MapContainer from '../components/GoogleMapsFinal'
import MapContainer from '../components/GoogleMapsFinal'

import '../css/Manage.css'
import Select from 'react-select'

import HeadingBox from '../components/HeadingBox'
import Swal from 'sweetalert2/dist/sweetalert2.js';
import axiosConfig from '../config/axiosConfig'
import ReminderAlert from '../components/ReminderAlert';
import AdvanceTableWithDeleteButton from '../components/Tables/AdvanceTableWithDeleteButton'
import AdvanceTableWithoutSearch from '../components/Tables/AdvanceTableWithoutSearch'


import FeatherIcon from 'feather-icons-react';

import { Link } from 'react-router-dom'; // Add this line



const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? '#7367f0' : 'white'
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '20px',
        borderColor: '#7367f0'

    })
}

const customStyles2 = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? '#7367f0' : 'white'
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '20px',
        borderColor: '#7367f0'

    })
}

const inputSMSOptions = new Promise((resolve) => {
    setTimeout(() => {
        resolve({
            '03331234567': '03331234567',
            '03109876541': '03109876541',
            'both': 'Both'
        })
    }, 1000)
})

const inputMileageOptions = new Promise((resolve) => {
    setTimeout(() => {
        resolve({
            'PKR': 'PKR',
            'Liters': 'Liters'

        })
    }, 1000)
})

const inputExcessiveFuelingOptions = new Promise((resolve) => {
    setTimeout(() => {
        resolve({
            'PKR': 'PKR',
            'Liters': 'Liters'

        })
    }, 1000)
})

const inputEmailOptions = new Promise((resolve) => {
    setTimeout(() => {
        resolve({
            'shariq@altpay.biz': 'shariq@altpay.biz',
            'safee@altpay.biz': 'safee@altpay.biz',
            'both': 'Both'
        })
    }, 1000)
})

class TestStepper extends Component {
    constructor() {
        super();
        this.state = {
            steps: [
                {
                    title: 'Step One',
                    onClick: (e) => {
                        e.preventDefault()
                    }
                },
                {
                    title: 'Step Two',
                    onClick: (e) => {
                        e.preventDefault()
                    }
                },
                {
                    title: 'Step Three',
                    onClick: (e) => {
                        e.preventDefault()
                    }
                }
                ,
                {
                    title: 'Step Four',
                    onClick: (e) => {
                        e.preventDefault()
                    }
                }
            ],
            currentStep: 0,
            valueLocation: '',
            valueMileage: '',
            valueTransactionMismatchAlert : '0.1',
            valueOverCapacity: '',
            valueQuantity: '',
            valueProduct: '',
            valueRunning: '',
            valueExcessiveFueling: '',

            locationIsChecked: false,
            mileageIsChecked: false,
            overCapacityIsChecked: false,
            quantityIsChecked: false,
            productIsChecked: false,
            runningMileageIsChecked: false,
            excessiveFuelingIsChecked: false,

            alertPushIsChecked: false,
            alertSMSIsChecked: false,
            alertEmailIsChecked: false,
            groupwiseIsChecked: false,
            stopNextIsChecked: false,
            categoryType: 1,

            outlets: [],
            openMap: false,
            categoryDropDownOptions: [],
            groups: [],
            items: [],

            suspiciousDropDownOptions: [
                { value: '0', label: 'Alert me via Push Notifications' },
                { value: '1', label: 'Alert me via SMS' },
                { value: '2', label: 'Alert me via Email' }
            ],

            locationShowHelp: false,
            OverCapacityShowHelp: false,
            VolumeMismatchShowHelp: false,
            LowShellShowHelp: false,
            deviatedRouteShowHelp: false,
            IsLocationMismatchTrans: true,
            excessiveDailyFuelingShowhelp: false,

            LOCATION_MISMATCH_TRANSACTIONS: 1,
            OVERCAPACITY_TRANSACTION: 2,
            VOLUME_MISMATCH: 3,
            LOW_SHELL_CARD_MILEAGE_ALERTS: 4,
            FUELING_ON_DEVIATED_ROUTES: 5,
            EXCESSIVE_DAILY_FUELING_ALERT: 6,
            allselectedSmsIds: '',
            newselectedSMSId: '',

            allselectedEmailIds: [],
            newselectedEmailId: [],
            SMSdata: [],
            AddedSMSdata : [],
            Emaildata: [],
            AddedEmaildata : [],
            IsAddedEmailGrid : true,
            IsAddedSMSGrid : true,
            suspicousActivity: [],
            allSelectedSMSAndEmailsID: [],
            vrnId: '0',
            groupid: '0',
            selectedVehicleGroup: '',
            SMScolumns: [

                { "HeaderText": "ID", "MappingColomn": "id" },
                { "HeaderText": "VRN","MappingColomn":"vrn"},
                { "HeaderText": "Name", "MappingColomn": "name" },
                { "HeaderText": "Contact No", "MappingColomn": "contactNo" },
               

            ],
            Emailcolumns: [
                { "HeaderText": "ID", "MappingColomn": "id" },
                { "HeaderText": "VRN","MappingColomn":"vrn"},
                { "HeaderText": "Name", "MappingColomn": "name" },
                { "HeaderText": "Email", "MappingColomn": "email" },
                
            ],

            allSelectedPointers: [],
            allSelectedOutlet: [],
            IsPushAlert: false,
            IsEmailChecked: false,
            IsSMSChecked: false,
            selectedItem: '',
            selectedCategory: '',
            DeletedSMSId: 0,
            DeletedEmailId: 0,
            hasError: false,//new state to show error
            ExcessiveFuelhasError : false
        }

        this.getSuspiciousTransactions = this.getSuspiciousTransactions.bind(this);
        this.onClickNext = this.onClickNext.bind(this);
        this.onClickPrevious = this.onClickPrevious.bind(this)

        // this.currentPage = this.currentPage.bind(this)

        this.LocationChange = this.LocationChange.bind(this)
        this.ProductMismatchChange = this.ProductMismatchChange.bind(this)
        this.QuantityChange = this.QuantityChange.bind(this)
        this.CardMileageChange = this.CardMileageChange.bind(this)
        this.OverCapacityChange = this.OverCapacityChange.bind(this)
        this.RunningMileageChange = this.RunningMileageChange.bind(this)
        this.changeGroup = this.changeGroup.bind(this)

        this.ChangeAlertPush = this.ChangeAlertPush.bind(this)
        this.ChangeAlertSMS = this.ChangeAlertSMS.bind(this)
        this.ChangeAlertEmail = this.ChangeAlertEmail.bind(this)


        this.LocationHelpValueChange = this.LocationHelpValueChange.bind(this)
        this.OverCapacityHelpValueChange = this.OverCapacityHelpValueChange.bind(this)
        this.VolumeMismatchHelpValueChange = this.VolumeMismatchHelpValueChange.bind(this)
        this.LowShellShowHelpValueChange = this.LowShellShowHelpValueChange.bind(this)
        this.deviatedRouteShowHelpValueChange = this.deviatedRouteShowHelpValueChange.bind(this)
        this.LocationMismatchTransaction = this.LocationMismatchTransaction.bind(this)

        this.callbackfunction_SMSalert = this.callbackfunction_SMSalert.bind(this);
        this.callbackfunction_Emailalert = this.callbackfunction_Emailalert.bind(this);
        this.VolumeMismatchTransaction = this.VolumeMismatchTransaction.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.VRNOnChange = this.VRNOnChange.bind(this)
        this.excessiveDailyFuelingAlertChange = this.excessiveDailyFuelingAlertChange.bind(this);
        this.ExcessiveFuelingChange = this.ExcessiveFuelingChange.bind(this);

        this.callbackfunction_SelectedOutlet = this.callbackfunction_SelectedOutlet.bind(this);

        this.callbackfunction_PushAlert = this.callbackfunction_PushAlert.bind(this);
        this.SetEmailCheck = this.SetEmailCheck.bind(this);
        this.SetEmailCheck = this.SetEmailCheck.bind(this);
        this.SetPushAlertNotification = this.SetPushAlertNotification.bind(this);
        
        this.GetDeleteSelectedRecordsPage_Email = this.GetDeleteSelectedRecordsPage_Email.bind(this);
        this.GetDeleteSelectedRecordsPage_SMS = this.GetDeleteSelectedRecordsPage_SMS.bind(this);
        this.GetDeleteSelectedRecords_Email = this.GetDeleteSelectedRecords_Email.bind(this);
        this.GetDeleteSelectedRecords_SMS = this.GetDeleteSelectedRecords_SMS.bind(this);
        
      
        this.BindSMSAndEmailGrid = this.BindSMSAndEmailGrid.bind(this);
        this.DataAddUpdate = this.DataAddUpdate.bind(this);
      
    }
    
   

    componentDidMount() {
        const data = {
            UserBranchID: this.props.data.selectedBranchId,
        }
        // axiosConfig.post('Portal/GetVRNGroupMapping', data)
        //     .then(res => {
        //         for (var i = 0; i < res.data.groupVRN.length; i++) {
        //             if(res.data.groupVRN[i].groupID !== 0){
        //             this.setState(prevState => ({
        //                 groups: [...prevState.groups, { value: res.data.groupVRN[i].groupID, label: res.data.groupVRN[i].groupName, vrn: res.data.groupVRN[i].vrnModel }]
        //             }))}
        //         }
        //     }
        //     )
        //     .catch(function (error) {
        //     }
        //     );

        axiosConfig.post('Portal/GetCategoryList', data)
            .then(res => {
                for (var i = 0; i < res.data.categories.length; i++) {
                    this.setState(prevState => ({
                        categoryDropDownOptions: [...prevState.categoryDropDownOptions, { value: res.data.categories[i].id, label: res.data.categories[i].type }]
                    }))
                }
            }
            )
            .catch(function (error) {
            }
            );



        let myarr = []
        let token = localStorage.getItem('token')
        axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig.post('Portal/GetUserEmail')
            .then(res => {
                myarr = res.data.userEmail
            }
            )
            .catch(function (error) {
            }
            )


        axiosConfig.post('Portal/GetOutlets', {})
            .then(res => {
                this.setState({ outlets: res.data.outlets })
            }
            )
            .catch(function (error) {
            }
            )
    }

    async changeGroup(selectedOption) {
        const data = {
            UserBranchID: this.props.data.selectedBranchId,
        }
        // var tmpArray = []
        // await this.setState({ groupid: selectedOption.value });
        // await this.setState({ selectedVehicleGroup: selectedOption.label });

        // this.setState({
        //     items: []
        // }, function () {
        //     let tmpArray = this.state.groups.find(groupid => groupid.value === selectedOption.value)
        //     tmpArray.vrn.map((el, index) => {
        //         this.setState(prevState => ({
        //             items: [...prevState.items,
        //             {
        //                 value: el.mappingID,
        //                 label: el.vrn
        //             }]
        //         }))

        //     })
        // });
        if (selectedOption.value == 1) {
            this.setState({
                items: []
            }, function () {
                // this.setState(prevState => ({
                //     items: [...prevState.items,
                //     { value: '0', label: 'ABC-123' },
                //     { value: '1', label: 'ABC-456' },
                //     { value: '2', label: 'ABC-789' }]
                // }))this.state.groups.value.length
                axiosConfig.post('Portal/GetVRNList', data)
                    .then(res => {
                        for (var i = 0; i < res.data.vrnlist.length; i++) {
                            this.setState(prevState => ({
                                items: [...prevState.items, { value: res.data.vrnlist[i].id, label: res.data.vrnlist[i].vrn }]
                            }))
                        }
                    }
                    )
                    .catch(function (error) {
                    }
                    );
            });

            this.setState({ selectedCategory: "Select Vehicle" });
            this.setState({ groupwiseIsChecked: false });
        }
        else {
            this.setState({
                items: []
            }, function () {
                // this.setState(prevState => ({
                //     items: [...prevState.items,
                //     { value: '0', label: 'Test' },
                //     { value: '1', label: 'Fleet' },
                //     { value: '2', label: 'Default' }]
                // }))
                axiosConfig.post('Portal/GetVRNGroupMapping', data)
                    .then(res => {
                        for (var i = 0; i < res.data.groupVRN.length; i++) {
                            if (res.data.groupVRN[i].groupID !== 0) {
                                this.setState(prevState => ({
                                    items: [...prevState.items, { value: res.data.groupVRN[i].groupID, label: res.data.groupVRN[i].groupName }]
                                }))
                            }
                        }
                    }
                    )
                    .catch(function (error) {
                    }
                    );
            });

            this.setState({ selectedCategory: "Select Group" });
            this.setState({ groupwiseIsChecked: true });
        }
    }
    LocationChange() {
        this.setState({ locationIsChecked: !this.state.locationIsChecked },
            function () {

                if (this.state.locationIsChecked) {
                    Swal.mixin({
                        input: '',
                        confirmButtonText: 'Next &rarr;',
                    }).queue([
                        {
                            title: 'Events',
                            text: 'Acceptable number of events per day'
                        },
                    ]).then((result) => {
                        if (result.value) {
                            const answers = JSON.stringify(result.value)
                            this.setState({
                                valueLocation: answers
                            })
                        }
                    })
                }
            }
        );
    }

    ChangeAlertPush() {
    }

    ChangeAlertSMS() {

        this.setState({ alertSMSIsChecked: !this.state.alertSMSIsChecked },
            function () {

                if (this.state.alertSMSIsChecked) {
                    Swal.mixin({
                        input: 'radio',
                        inputOptions: inputSMSOptions,
                        confirmButtonText: 'Next &rarr;',
                    }).queue([
                        {
                            title: 'SMS Alerts',
                            text: 'Send me alert on the numbers'
                        },
                    ]).then((result) => {
                        if (result.value) {
                            const answers = JSON.stringify(result.value)
                            this.setState({
                                valueLocation: answers
                            })
                        }
                    })
                }
            }
        );

    }

    ChangeAlertEmail() {
        this.setState({ alertEmailIsChecked: !this.state.alertEmailIsChecked },
            function () {

                if (this.state.alertEmailIsChecked) {
                    Swal.mixin({
                        input: 'radio',
                        inputOptions: inputEmailOptions,
                        confirmButtonText: 'Next &rarr;',
                    }).queue([
                        {
                            title: 'Email Alerts',
                            text: 'Send me alert on the Emails'
                        },
                    ]).then((result) => {
                        if (result.value) {
                            const answers = JSON.stringify(result.value)
                            this.setState({
                                valueLocation: answers
                            })
                        }
                    })
                }
            }
        );

    }

    CardMileageChange() {
        this.setState({ mileageIsChecked: !this.state.mileageIsChecked },
            function () {

                if (this.state.mileageIsChecked) {
                    Swal.mixin({
                        input: 'text',
                        confirmButtonText: 'Next &rarr;',
                        showCancelButton: true
                    }).queue([
                        {
                            title: 'Minimum Mileage in KM/L ',
                            html: '<small><div style="text-align:left;">The concept of Mileage can be illustrated through the example below:<br/><br />' +
                                '12/04/2021 6.54pm: Shell Card charged for 30 liters<br/>' +
                                '17/04/2021 7.20pm: Shell card charged for 15 Liters <br/>' +
                                'Distance travelled by Vehicle between two transactions: 250 KMs <br/>' +
                                'Shell Card Mileage of the 12/04/2021 Transaction:  8.33 KM/L<div><small>'
                                
                        }
                    ]).then((result) => {
                        if (result.value) {
                            const answers = JSON.stringify(result.value)
                            // alert(result.value);
                            this.setState({
                                valueMileage: answers
                            })
                        }
                    })
                }
            }
        );
    }

    OverCapacityChange() {
        this.setState({ overCapacityIsChecked: !this.state.overCapacityIsChecked },
            function () {

                if (this.state.overCapacityIsChecked) {
                    Swal.mixin({

                        confirmButtonText: 'Next &rarr;',
                        showCancelButton: true,
                        progressSteps: ['1', '2']
                    }).queue([
                        {
                            input: 'radio',
                            inputOptions: inputMileageOptions,
                            title: 'Set the Maximum Threshold',
                            //text: 'Acceptable Variance threshold per event'
                        },
                        {
                            input: 'text',
                            title: 'Set the Value',
                            //text: 'Acceptable number of events'
                        },
                    ]).then((result) => {
                        if (result.value) {
                            const answers = JSON.stringify(result.value)
                            // Swal.fire({
                            //     title: 'Location Mismatched Transactions',
                            //     html: `
                            //   Your Input:
                            //   <pre><code>${answers}</code></pre>
                            // `,
                            //     confirmButtonText: 'OK'
                            // })



                            this.setState({
                                valueOverCapacity: answers
                            })


                        }
                    })

                }

            }


        );



    }


    RunningMileageChange() {
        this.setState({ runningMileageIsChecked: !this.state.runningMileageIsChecked },
        );



    }
    
 
      
      
      
      
   
  
      
    ExcessiveFuelingChange() {
        this.setState({ excessiveFuelingIsChecked: !this.state.excessiveFuelingIsChecked },
            
            function () {
                debugger
                if (this.state.excessiveFuelingIsChecked) {
                    // Swal.mixin({

                    //     confirmButtonText: 'Next &rarr;',
                    //     showCancelButton: true,
                    //     // progressSteps: ['1', '2'],
                    //     progressSteps: ['1']
                    // }).queue([
                    //     // {
                    //     //     input: 'radio',
                    //     //     inputOptions: inputExcessiveFuelingOptions,
                    //     //     title: 'Set the Maximum Threshold',
                    //     //     text: 'Excessive Fueling per 24hrs.'
                    //     // },
                    //     {
                    //         input: 'text',
                    //         title: 'Set the Daily Limit in Ltrs',
                    //         //text: 'Acceptable number of events'
                    //     },
                    // ]).then((result) => {
                    //     if (result.value) {
                    //         const answers = JSON.stringify(result.value)
                    //         this.setState({
                    //             valueExcessiveFueling: answers
                    //         })
                    //     }
                    // })
                    Swal.mixin({
                        confirmButtonText: 'Save',
                        showCancelButton: true,
                        progressSteps: ['1']
                      }).queue([
                        {
                          input: 'text',
                          title: 'Set the Daily Limit in Ltrs',
                        },
                      ]).then((result) => {
                        if (result.value) {

                          debugger
                          let inputValue = result.value[0];
                          inputValue = inputValue.trim();
                          if(inputValue == '0')
                          {
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                text: 'Please enter valid value.',
                                confirmButtonText: 'OK'
                              });
                          }
                          else if (/^[0-9\s.]+$/.test(inputValue)) {
                            //const answers = JSON.stringify(result.value);
             
                            
                            this.setState({
                              valueExcessiveFueling: inputValue
                            });
                          } else {
                            Swal.fire({
                              icon: 'error',
                              title: 'Error',
                              text: 'Please enter only numeric values.',
                              confirmButtonText: 'OK'
                            });
                          }
                        }
                      });
                      
                      
                      
                      
                }
            }
        );
    }
   

    QuantityChange() {
        this.setState({ quantityIsChecked: !this.state.quantityIsChecked },
            function () {
                if (this.state.quantityIsChecked) {
                    Swal.mixin({
                        input: 'text',
                        confirmButtonText: 'Next &rarr;',
                    }).queue([
                        {
                            title: 'Events',
                            text: 'Acceptable number of events per day'
                        },
                    ]).then((result) => {
                        if (result.value) {
                            const answers = JSON.stringify(result.value)
                            this.setState({
                                valueQuantity: answers
                            })
                        }
                    })
                }
            }
        );
    }

    ProductMismatchChange() {
        this.setState({ productIsChecked: !this.state.productIsChecked },
            function () {

                if (this.state.productIsChecked) {
                    Swal.mixin({
                        input: 'text',
                        confirmButtonText: 'Next &rarr;',
                    }).queue([
                        {
                            title: 'Events',
                            text: 'Acceptable number of events per day'
                        },
                    ]).then((result) => {
                        if (result.value) {
                            const answers = JSON.stringify(result.value)
                            this.setState({
                                valueProduct: answers
                            })
                        }
                    })
                }

            }


        );



    }

    async handleSubmit(e) {

       // e.preventDefault();
        debugger
        if (this.state.groupid === "") {

            Swal.fire({
                title: 'Error !',
                text: 'Please Select Vehicle group.',
                icon: 'error',
                confirmButtonText: 'Okay'
            })

            return false;
        }

        // if (this.state.vrnId === "0") {

        //     Swal.fire({
        //         title: 'Error !',
        //         text: 'Please Select Vehicle.',
        //         icon: 'error',
        //         confirmButtonText: 'Okay'
        //     })

        //     return false;
        // }


        let token = localStorage.getItem('token');
        let cards = []

        if (this.state.IsLocationMismatchTrans) {
            let val = this.state.valueTransactionMismatchAlert;
            let card = {
                ID: this.state.LOCATION_MISMATCH_TRANSACTIONS,
                // AccompayingInfo1: valuesArray[0],
              
                AccompayingInfo1: "Dia",
                AccompayingInfo2: val,
            }
            cards.push(card);
        }

        if (this.state.overCapacityIsChecked) {
            debugger
            let valuesArray = JSON.parse(this.state.valueOverCapacity);
            let card = {
                ID: this.state.OVERCAPACITY_TRANSACTION,
                AccompayingInfo1: valuesArray[0],
                // AccompayingInfo1: "Liters",
                AccompayingInfo2: valuesArray[1]
            }
            cards.push(card);
        }

        if (this.state.VolumeMismatchShowHelp) {
            let card = {
                ID: this.state.VOLUME_MISMATCH
            }
            cards.push(card);
        }

        if (this.state.mileageIsChecked) {



            let valuesArray = JSON.parse(this.state.valueMileage);
            let card = {
                ID: this.state.LOW_SHELL_CARD_MILEAGE_ALERTS,
                AccompayingInfo1: "valueMileage",
                AccompayingInfo2: valuesArray[0]
            }
            cards.push(card);
        }

        if (this.state.runningMileageIsChecked) {

            let card = {
                ID: this.state.FUELING_ON_DEVIATED_ROUTES
            }
            cards.push(card);
        }
        if (this.state.excessiveFuelingIsChecked) {
            let valuesArray = JSON.parse(this.state.valueExcessiveFueling);
            let card = {
                ID: this.state.EXCESSIVE_DAILY_FUELING_ALERT,
                // AccompayingInfo1: valuesArray[0],
                // AccompayingInfo2: valuesArray[1]

                AccompayingInfo1: "Liters",
                AccompayingInfo2: this.state.valueExcessiveFueling
            }
            cards.push(card);
        }

        await this.setState(
            {
                suspicousActivity: cards
            })

        if (this.state.suspicousActivity.length === 0) {
            Swal.fire({
                title: 'Error !',
                text: 'Please Allow Suspicious Activities.',
                icon: 'error',
                confirmButtonText: 'Okay'
            })
            return false;
        }

        let allSelectedSMSAndEmailsIDs = []
        for (var i = 0; i < this.state.newselectedSMSId.length; i++) {
            let a = this.state.newselectedSMSId[i].SelectedSMSValue
            allSelectedSMSAndEmailsIDs.push(a);
        }

        for (var i = 0; i < this.state.newselectedEmailId.length; i++) {
            let a = this.state.newselectedEmailId[i].SelectedEmailValue
            allSelectedSMSAndEmailsIDs.push(a);
        }

        await this.setState(
            {
                allSelectedSMSAndEmailsID: allSelectedSMSAndEmailsIDs
            })


        let allSelectedOutletIds_string = []
        for (var i = 0; i < this.state.allSelectedOutlet.length; i++) {
            let a = this.state.allSelectedOutlet[i].outletID
            allSelectedOutletIds_string.push(a);
        }
        await this.setState(
            {
                allSelectedPointers: allSelectedOutletIds_string
            })

        axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig.post("Portal/SuspiciousTransaction",
            {
                TelematicsCardVRNMappingMasterID: this.state.vrnId, //this.state.groupID,
                SuspiciousType: this.state.suspicousActivity,
                UserProfileID: this.state.allSelectedSMSAndEmailsID,
                OutletID: this.state.allSelectedPointers,
                IsAlertChecked: this.state.IsPushAlert,
                GroupID: this.state.groupid,
                CategoryTypeID: this.state.categoryType
            }
        )
            .then(Response => {
                
                Swal.fire({
                    icon: 'success',
                    title: 'Saved Successfully',
                })
                debugger
                //this.props.history.push('/ManageSusTransSub')
                this.BindSMSAndEmailGrid();
            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })
        /*End*/
    }


    callbackfunction_SelectedOutlet = (childData) => {

        var temp = this.state.allSelectedOutlet;
        this.setState({ allSelectedOutlet: childData })
    }

    callbackfunction_PushAlert = (childData) => {

        this.setState({ IsPushAlert: childData })
    }


    callbackfunction_SMSalert = (childData) => {
        debugger
        var temp = this.state.newselectedSMSId;
        this.setState({ newselectedSMSId: childData})
    
        this.setState(({
            AddedSMSdata: []
        }));
        for(var i=0;(i < childData.length) && (childData.length > 0) ; i++)
        {
        const originalString = childData[i].SelectedSMSText;
        const substringToFind = '-';
        
        const position = originalString.indexOf(substringToFind);
        let extractedSubstring = "";
        let PreextractedSubString = "";
        if (position !== -1) {
           extractedSubstring = originalString.substring(position+2, position + originalString.length-1);
           PreextractedSubString = originalString.substring(0,position-1)
          console.log("Found:", extractedSubstring); 
          console.log("Found:",PreextractedSubString);// Output: "Found: world"
        } else {
          console.log("Substring not found");
        }
        const containsValue = (this.state.SMSdata) ? this.state.SMSdata.some(item => item.contactNo === extractedSubstring) : false;  
        if(!containsValue) 
        {
        const newItem =  { id: childData[i].SelectedSMSValue, name: PreextractedSubString,contactNo:extractedSubstring }
    this.setState(prevState => ({
        AddedSMSdata: [...prevState.AddedSMSdata, newItem]
    }));
    this.setState(({IsAddedEmailGrid:true}));
    this.setState(({IsAddedSMSGrid:true}));
}

        console.log(this.state.AddedSMSdata);
}
}

    callbackfunction_Emailalert = (childData) => {

        debugger
        var temp = this.state.newselectedEmailId;
        this.setState({ newselectedEmailId: childData})
       
        // this.setState({ newselectedEmailId: 17 })
        this.setState(({
            AddedEmaildata: []
        }));
        for(var i=0;(i < childData.length) && (childData.length > 0) ; i++)
        {
        const originalString = childData[i].SelectedEmailText;  
        

   
const substringToFind = '-';

const position = originalString.indexOf(substringToFind);
let extractedSubstring = "";
        let PreextractedSubString = "";
        if (position !== -1) {
          extractedSubstring = originalString.substring(position+2, position + originalString.length-1);
          PreextractedSubString = originalString.substring(0,position-1)
          console.log("Found:", extractedSubstring); 
          console.log("Found:",PreextractedSubString);// Output: "Found: world"
        } else {
          console.log("Substring not found");
        }
        const containsValue = (this.state.Emaildata)? this.state.Emaildata.some(item => item.email === extractedSubstring) : false;  
        if(!containsValue) 
        {
        const newItem =  { id: childData[i].SelectedEmailValue, name:PreextractedSubString,email:extractedSubstring }
    this.setState(prevState => ({
        AddedEmaildata: [...prevState.AddedEmaildata, newItem]
    }));
    this.setState(({IsAddedEmailGrid:true}));
    this.setState(({IsAddedSMSGrid:true}));
        }
       
    }
   


        console.log(this.state.AddedEmaildata);
      
    }


    SetSMSCheck = (childData) => {
        this.setState({ IsSMSChecked: childData })
    }

    SetEmailCheck = (childData) => {
        this.setState({ IsEmailChecked: childData })
    }



    SetPushAlertNotification = (childData) => {
        this.setState({ IsPushAlert: childData })
    }

    onClickNext() {
        debugger
        console.log(this.state.currentStep);
        if (this.state.selectedCategory === "") {
            if (this.state.currentStep == 0) {

                Swal.fire({
                    title: 'Error !',
                    text: 'Please Select Category.',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })

                return false;
            }
        }
        if (this.state.currentStep == 1) {
            if (this.state.selectedItem === "") {
                if (this.state.groupwiseIsChecked === true) {
                    Swal.fire({
                        title: 'Error !',
                        text: 'Please Select Any Group first.',
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                }
                else
                {
                    Swal.fire({
                        title: 'Error !',
                        text: 'Please Select Any Vehicle first.',
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                }

                return false;
            }
            
            

            var categoryTypeId;
            var vrn;
            if (this.state.groupwiseIsChecked === true) {
                axiosConfig.post('Portal/GetCategoryType',
                    {
                        GroupID: this.state.groupid,
                    }
                )
                    .then(res => {
                        this.setState({ categoryTypeId: res.data.categoryTypeID });
                        this.setState({ vrn: res.data.vrn });
                        if (this.state.categoryTypeId === 1) {
                            this.swalConfirm(this.state.vrn);
                        }
                        else {
                            this.getSuspiciousTransactions();
                            if (this.state.currentStep < 3)
                                this.setState({
                                    currentStep: this.state.currentStep + 1,
                                });
                        }
                    }
                    )
                    .catch(function (error) {
                    }
                    )

            }
            else {
                // axiosConfig.post('Portal/GetCategoryType',
                //     {
                //             TelematicsCardVRNMappingMasterID: this.state.vrnId,
                //     }
                // )
                //     .then(res => {
                //         this.setState({ categoryType: res.CategoryTypeID })
                //         if (this.state.categoryType === 2) {
                //             Swal.fire({
                //                 title: 'UnAuthorized',
                //                 text: 'You can not Manage this vehicle as it is Managed as Group !',
                //                 icon: 'error',
                //                 confirmButtonText: 'Okay'
                //             })
                //         }
                //         else {
                //             this.onClickNext();
                //             if (this.state.currentStep < 3)
                //                 this.setState({
                //                     currentStep: this.state.currentStep + 1,
                //                 });
                //         }
                //     }
                //     )
                //     .catch(function (error) {
                //     }
                //     )
                this.setState({
                    IsLocationMismatchTrans: true
                })
                this.getSuspiciousTransactions();
                this.setState({
                    currentStep: this.state.currentStep + 1,
                });
            }
        }
        else {
            if (this.state.currentStep == 2) {
                if (this.state.valueTransactionMismatchAlert === "") {
                    
                        Swal.fire({
                            title: 'Error !',
                            text: 'Please Select Allowed Distance Variation Value.',
                            icon: 'error',
                            confirmButtonText: 'Okay'
                        })

                        return false;
                   
                    }
                else if(this.state.valueExcessiveFueling === '' && this.state.excessiveFuelingIsChecked)
                {

                    Swal.fire({
                        title: 'Error !',
                        text: 'Please Enter Excessive Fueling Value.',
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })

                    return false;

                   }
                    else
                    {
                        this.setState({
                            currentStep: this.state.currentStep + 1,
                        });
                    }
    
                    
                }
                else
                {
          
            if (this.state.currentStep < 3)
                this.setState({
                    currentStep: this.state.currentStep + 1,
                });
            }
            
        }
    }

    swalConfirm(vrn) {

        Swal.fire({
            title: 'Are you sure?',
            text: "(" + this.state.vrn + ") already has alerts applied on it. Do you wish to set new alerts for this vehicle/card?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Proceed!'
        }).then((result) => {
            if (result.isConfirmed) {

                this.getSuspiciousTransactions();
                this.setState({
                    currentStep: this.state.currentStep + 1,
                });
                // axiosConfig.delete("Portal/DeleteVRNGroupMapping",
                //     {
                //         data: {
                //             GroupId: groupid,
                //             UserBranchID: branchID,
                //         }
                //     }
                // )
                //     .then(Response => {
                //     })
                //     .catch(error => {
                //     })
            }
        })
    }

    getSuspiciousTransactions() {

        debugger
        var self = this;
        // self will now be referred to your component
        let token = localStorage.getItem('token')
        /*Start:Get Suspicious Transaction Work */
        axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig.post('Portal/GetSuspiciousTransactions', {
            TelematicsCardVRNMappingMasterID: this.state.vrnId,
            GroupID: this.state.groupid
        }
        )
            .then(res => {
                this.setState({
                    IsLocationMismatchTrans: true
                })
                for (var i = 0; i < res.data.suspiciousTransactions.length; i++) {

                    if (res.data.suspiciousTransactions[i].suspiciousType === "LOCATION_MISMATCH_TRANSACTIONS") {

                        this.setState({
                            IsLocationMismatchTrans: true
                        })
                        let val = res.data.suspiciousTransactions[i].accompanyingInfo2
                        this.setState({
                            valueTransactionMismatchAlert : val
                        })
                    }

                    else if (res.data.suspiciousTransactions[i].suspiciousType === "OVERCAPACITY_TRANSACTION") {
                        let val = '["' + res.data.suspiciousTransactions[i].accompanyingInfo1 + '",' + '"' + res.data.suspiciousTransactions[i].accompanyingInfo2 + '"]';

                        this.setState({
                            overCapacityIsChecked: true,
                            valueOverCapacity: val
                        })
                    }

                    else if (res.data.suspiciousTransactions[i].suspiciousType === "VOLUME_MISMATCH") {
                        this.setState({
                            VolumeMismatchShowHelp: true
                        })
                    }

                    else if (res.data.suspiciousTransactions[i].suspiciousType === "LOW_SHELL_CARD_MILEAGE_ALERTS") {

                        let val = '["' + res.data.suspiciousTransactions[i].accompanyingInfo2 + '"]';

                        this.setState({
                            mileageIsChecked: true,
                            valueMileage: val
                        })
                    }

                    else if (res.data.suspiciousTransactions[i].suspiciousType === "FUELING_ON_DEVIATED_ROUTES") {
                        let myobj = res.data.suspiciousTransactions[i].accompanyingInfo1 + ":" + res.data.suspiciousTransactions[i].accompanyingInfo2;

                        var obj = JSON.stringify(myobj);

                        this.setState({
                            runningMileageIsChecked: true,
                            valueRunning: obj
                        })
                    }
                    else if (res.data.suspiciousTransactions[i].suspiciousType === "EXCESSIVE_DAILY_FUELING_ALERT") {
                        let val = '["' + res.data.suspiciousTransactions[i].accompanyingInfo1 + '",' + '"' + res.data.suspiciousTransactions[i].accompanyingInfo2 + '"]';
                        val = res.data.suspiciousTransactions[i].accompanyingInfo2
                        let commaIndex = val.indexOf(',', val.indexOf('['));

                        // Extract the substring after the comma
                        let extractedValue = val.substring(commaIndex + 2, val.length - 2);
                        console.log(extractedValue,'extracteValue')

                        this.setState({
                            excessiveFuelingIsChecked: true,
                            valueExcessiveFueling: val
                        })
                    }
                }

                if (res.data.smsList != null && res.data.smsList.length > 0) {
                    this.setState({
                        IsSMSChecked: true
                    })
                }
                if (res.data.emailList != null && res.data.emailList.length > 0) {
                    this.setState({
                        IsEmailChecked: true
                    })
                }

                this.BindSMSAndEmailGrid();

                if (res.data.deviatedOutlet != null && res.data.deviatedOutlet.length > 0) {
                    this.setState({
                        allSelectedOutlet: res.data.deviatedOutlet
                    })
                }

                if (res.data.pushAlert != null && res.data.pushAlert.length > 0) {
                    this.setState({
                        IsPushAlert: res.data.pushAlert[0].isPushAlert
                    })
                }


            }
            )
            .catch(function (error) {
                self.setState({
                    IsLocationMismatchTrans: true,
                    overCapacityIsChecked: false,
                    valueOverCapacity: '',
                    VolumeMismatchShowHelp: false,
                    mileageIsChecked: false,
                    valueMileage: '',
                    runningMileageIsChecked: false,
                    valueRunning: '',
                    excessiveFuelingIsChecked: false,
                    valueExcessiveFueling: '',
                    SMSdata: [],
                    Emaildata: [],
                });
            }
            )

    }

    onClickPrevious() {
        if (this.state.currentStep > 0) {
            this.setState({
                currentStep: this.state.currentStep - 1,
            });

            if (this.state.currentStep === 1) {
                this.setState({
                    selectedItem: '', selectedCategory: ''
                });
            }
        }
    }

    LocationHelpValueChange(e) {
        this.setState(
            { locationShowHelp: !this.state.locationShowHelp }
        )
    }

    OverCapacityHelpValueChange(e) {
        this.setState(
            { OverCapacityShowHelp: !this.state.OverCapacityShowHelp }
        )
    }

    VolumeMismatchHelpValueChange(e) {
        this.setState(
            { VolumeMismatchShowHelp: !this.state.VolumeMismatchShowHelp }
        )
    }

    LowShellShowHelpValueChange(e) {
        this.setState(
            { LowShellShowHelp: !this.state.LowShellShowHelp }
        )
    }

    deviatedRouteShowHelpValueChange(e) {
        this.setState(
            { deviatedRouteShowHelp: !this.state.deviatedRouteShowHelp }
        )
    }

    excessiveDailyFuelingAlertChange(e) {
        this.setState(
            { excessiveDailyFuelingShowhelp: !this.state.excessiveDailyFuelingShowhelp }
        );
    }

    LocationMismatchTransaction(e) {
        if (e.currentTarget.checked) {
            this.setState({ IsLocationMismatchTrans: true });
        }
        else {
            this.setState({ IsLocationMismatchTrans: false });
        }
    }

    VolumeMismatchTransaction(e) {
        if (e.currentTarget.checked) {
            this.setState({ VolumeMismatchShowHelp: true });
        }
        else {
            this.setState({ VolumeMismatchShowHelp: false });
        }
    }


    async VRNOnChange(selectedOption) {

        if (this.state.groupwiseIsChecked === true) {
            this.setState({ categoryType: 2 });
            await this.setState({ groupid: selectedOption.value, vrnId: "0", selectedItem: "Group " + selectedOption.label });
        }
        else {
            this.setState({ categoryType: 1 });
            await this.setState({ vrnId: selectedOption.value, groupid: "0", selectedItem: "Vehicle " + selectedOption.label });
        }

    }
    BindSMSAndEmailGrid() {
        debugger
        var self = this; // self will now be referred to your component
        let token = localStorage.getItem('token')
        axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig.post("Portal/GetSuspiciousSMSDetail", {
            TelematicsCardVRNMappingMasterID: this.state.vrnId,
            GroupID: this.state.groupid
        })
            .then(res => {

                this.setState({
                    SMSdata: res.data.smsList,
                });

            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })


        axiosConfig.defaults.headers.common['Token'] = token;
        axiosConfig.post("Portal/GetSuspiciousEmailDetail", {
            TelematicsCardVRNMappingMasterID: this.state.vrnId,
            GroupID: this.state.groupid
        })
            .then(res => {

                this.setState({
                    Emaildata: res.data.emailList,
                })

            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })
    }


    async resetStateIfNoSuspiciousTranDataFound(e) {

        await this.setState({
            IsLocationMismatchTrans: false,
            overCapacityIsChecked: false,
            valueOverCapacity: '',
            VolumeMismatchShowHelp: false,
            mileageIsChecked: false,
            valueMileage: '',
            runningMileageIsChecked: false,
            valueRunning: '',
            excessiveFuelingIsChecked: false,
            valueExcessiveFueling: ''
        });
    }

    GetDeleteSelectedRecords_Email = (childData) => {
        this.setState({ DeletedEmailId: childData.id });

        let token = localStorage.getItem('token')
        axiosConfig.defaults.headers.common['Token'] = token;
        const data = {
            UserProfileId: this.state.DeletedEmailId
        }
        axiosConfig.post("Portal/DeactiveSuspiciousAlert", data)
            .then(res => {
                this.BindSMSAndEmailGrid();
                Swal.fire(
                    'Deleted!',
                    'Email has been deleted.',
                    'success'
                )
                this.setState({
                    newselectedEmailId: [],
                    newselectedSMSId:[]
                })
            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })

    }

    GetDeleteSelectedRecords_SMS = (childData) => {

        this.setState({ DeletedSMSId: childData.id })

        const data = {
            UserProfileId: this.state.DeletedSMSId
        }
        axiosConfig.post("Portal/DeactiveSuspiciousAlert", data)
            .then(res => {
                this.BindSMSAndEmailGrid();
                Swal.fire(
                    'Deleted!',
                    'SMS Mobile No has been deleted.',
                    'success'
                )
                this.setState({
                    newselectedEmailId: [],
                    newselectedSMSId:[]
                })
            })
            .catch(error => {
                Swal.fire({
                    title: error.response.data.errorMessage,
                    text: 'Some Error !',
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })
            
    }

    GetDeleteSelectedRecordsPage_Email = (childData) => {
        debugger;
        
        const filteredData = this.state.AddedEmaildata.filter(item => item.id !== childData.id);
        this.setState({ AddedEmaildata: filteredData });

        const filteredSelectedData = this.state.newselectedEmailId.filter(item => item.SelectedEmailValue != childData.id)
        this.setState({newselectedEmailId : filteredSelectedData})
        Swal.fire(
          'Deleted!',
          'Email record has been deleted.',
          'success'
        );
      }

    GetDeleteSelectedRecordsPage_SMS = (childData) =>
    { 
    
     debugger   
    const filteredData = this.state.AddedSMSdata.filter(item => item.id !== childData.id);
    debugger
    this.setState({ AddedSMSdata: filteredData });
    const filteredSelectedData = this.state.newselectedSMSId.filter(item => item.SelectedSMSValue != childData.id)
    this.setState({newselectedSMSId : filteredSelectedData})
    
  
    Swal.fire(
      'Deleted!',
      'SMS record has been deleted.',
      'success'
    );
  }

 DataAddUpdate = () =>{
    debugger
    this.handleSubmit();
    this.BindSMSAndEmailGrid();
    
   
 }





    render() {
        const { steps, currentStep } = this.state;
        const buttonStyle = { background: '#E0E0E0', width: 200, padding: 16, textAlign: 'center', margin: '0 auto', marginTop: 32 };
        const { TelematicsCardVRNMappingMasterID, VehicleId, IsLocationMismatchTrans, email, mobileNo, mobileNo1, mobileNo2, email1, email2, selectedVehicleGroup } = this.state;


        return (

            <>
               
               
          <div style={{ textAlign: 'left', marginLeft: '30px' }}>

<Link to="/ManageSusTransSub" className="btn btn-shell mr-1 mb-1">Back</Link> {/* Add this line */}

</div>
                <Container>
                  

                    <HeadingBox title="You can only receive Suspicious Transaction Alerts for Shell Cards that are part of a Combination and have been mapped to a Vehicle"></HeadingBox>


                    <CardDeck className="text-left">
                        <Card>
                            <Card.Title className="px-3 mt-3">
                                Manage Suspicious Transactions
                                <div className="pull-center">
                                    <small>{this.state.selectedItem}</small>
                                </div>
                            </Card.Title>

                            <Card.Body>

                                <Stepper
                                    steps={steps}
                                    activeStep={currentStep}
                                    activeColor="#ffd500"
                                    defaultBarColor="#ffd500"
                                    completeColor="red"
                                    // completeColor="red"
                                    completeBarColor="#ffd500"
                                    defaultBorderColor="green"
                                    
                                />


                                {currentStep === 0 && (
                                    <>


                                        <div className="d-flex align-items-center justify-content-center" style={{ height: 'calc(20vh - 20px)' }}>




                                            <div className="col-sm-2 col-12">
                                                <div>Please Select Category</div>
                                            </div>

                                            <div className="col-sm-3 col-12">
                                                <Select className=""
                                                    options={this.state.categoryDropDownOptions}
                                                    styles={customStyles}
                                                    onChange={this.changeGroup} required>

                                                </Select>

                                            </div>

                                        </div>

                                    </>

                                )}


                                {currentStep === 1 && (

                                    <div className="d-flex align-items-center justify-content-center" style={{ height: 'calc(20vh - 20px)' }}>
                                        <div className="col-sm-2 col-12">
                                            <div className="iconspacing-Nav">{this.state.selectedCategory}</div>
                                        </div>

                                        <div className="col-sm-3 col-12">
                                            <Select className=""
                                                options={this.state.items}
                                                styles={customStyles}
                                                onChange={this.VRNOnChange} required>

                                            </Select>

                                        </div>

                                    </div>
                                    

                                )}

                                {currentStep === 2 && (

                                    <div className="mt-4">
                                        <h5 className="pl-0">Select Suspicious Transaction</h5>
                                        <CardDeck>
                                            <Card>
                                                <Card.Body>
                                                    <div className="border border-secondary rounded p-3">

                                                        <a name="locationShowHelp" onClick={this.LocationHelpValueChange}>
                                                            <FeatherIcon className="iconspacing pull-right" icon="help-circle" size="18" />
                                                        </a>
                                                        <strong>Location Mismatch <br /> Alert - Allowed Distance Variation in KM</strong>
                                                        {/* <label className="switch">
                                                            <input type="checkbox" className="warning" onChange={this.LocationMismatchTransaction} checked={this.state.IsLocationMismatchTrans} disabled={true}  />
                                                            <span className="slider round" />
                                                            <br />
                                                        </label> */}

                                                        <div className="text-success mt-2 ">
                                                            
                                                                {/* <input type="text"  value={this.state.valueTransactionMismatchAlert}  onChange={(event) => {
          this.setState({
            valueTransactionMismatchAlert: event.target.value,
          });
        }}></input> */}<div>
     <input
          type="text"
          value={this.state.valueTransactionMismatchAlert}
          onInput={(event) => {
            const inputValue = event.target.value;
            if (/^[0-9]*\.?[0-9]*$/.test(inputValue)) {
              this.setState({
                valueTransactionMismatchAlert: inputValue,
                hasError: false,
              });
            } else {
              this.setState({
                hasError: true,
              });
            }
          }}
          className={this.state.hasError ? 'error' : ''}
        />
        {this.state.hasError && <p className="error-message">Please enter only numeric characters.</p>}
      
      </div>
                                                            
                                                        </div>
                                                    </div>

                                                    {
                                                        this.state.locationShowHelp
                                                            ?
                                                            <div className="text-secondary text-justify">
                                                                <small>
                                                                You will be alerted when the distance variation is greater than the allowed variation. The distance variation is the distance between the vehicle’s location and the Shell Card site where the transaction occurred.
                                                                </small>

                                                            </div>
                                                            :
                                                            <div></div>

                                                    }




                                                </Card.Body>
                                            </Card>
                                            {/* <Card>
                                                <Card.Body>
                                                    <div className="border border-secondary rounded p-3">
                                                        <a onClick={this.OverCapacityHelpValueChange}>
                                                            <FeatherIcon className="iconspacing pull-right" icon="help-circle" size="18" />
                                                        </a>
                                                        <strong>Overcapacity <br /> Transaction</strong>
                                                        <label className="switch">
                                                            <input type="checkbox" className="warning" onChange={this.OverCapacityChange} checked={this.state.overCapacityIsChecked} />
                                                            <span className="slider round" />
                                                        </label>
                                                        <div className="text-success ">
                                                            <small>
                                                                Maximum Threshold : {this.state.valueOverCapacity}
                                                            </small>
                                                        </div>
                                                    </div>


                                                    {
                                                        this.state.OverCapacityShowHelp
                                                            ?
                                                            <div className="text-secondary text-justify">
                                                                <small>
                                                                    If enabled, you will receive an alert each time a Shell Card transaction occurs that is greater than the Maximum Threshold you have set.
                                                                </small>

                                                            </div>
                                                            :
                                                            <div></div>

                                                    }

                                                </Card.Body>
                                            </Card>
                                            <Card>
                                                <Card.Body>



                                                    <div className="border border-secondary rounded p-3">
                                                        <a onClick={this.VolumeMismatchHelpValueChange}>
                                                            <FeatherIcon className="iconspacing pull-right" icon="help-circle" size="18" />
                                                        </a>
                                                        <strong>Volume  Mismatch<br /> Transaction</strong>
                                                        <label className="switch">
                                                            <input type="checkbox" className="warning" onChange={this.VolumeMismatchTransaction} checked={this.state.VolumeMismatchShowHelp} />
                                                            <span className="slider round" />
                                                        </label>
                                                        <div className="text-success ">
                                                            <small>
                                                                &nbsp;
                                                            </small>
                                                        </div>
                                                    </div>


                                                    {
                                                        this.state.VolumeMismatchShowHelp
                                                            ?
                                                            <div className="text-secondary text-justify">
                                                                <small>
                                                                    If enabled, you will receive an alert each time a Shell Card Transaction occurs that is greater than the tank fill recorded via the Fuel Sensor of the vehicle.
                                                                </small>

                                                            </div>
                                                            :
                                                            <div></div>

                                                    }

                                                </Card.Body>
                                            </Card> */}
                                        {/* </CardDeck>
                                        <CardDeck> */}
                                            {/* <Card>
                                                <Card.Body>
                                                    <div className="border border-secondary rounded p-3">
                                                        <a onClick={this.LowShellShowHelpValueChange}>
                                                            <FeatherIcon className="iconspacing pull-right" icon="help-circle" size="18" />
                                                        </a>
                                                        <strong>Low Vehicle Shell Card <br /> Mileage Transaction</strong>
                                                        <label className="switch">
                                                            <input type="checkbox" className="warning" onChange={this.CardMileageChange} checked={this.state.mileageIsChecked} />
                                                            <span className="slider round" />
                                                        </label>
                                                        <div className="text-success ">
                                                            <small>
                                                                Minimum Mileage : {this.state.valueMileage}
                                                            </small>
                                                        </div>
                                                    </div>
                                                    {
                                                        this.state.LowShellShowHelp
                                                            ?
                                                            <div className="text-secondary text-justify">
                                                                <small>
                                                                    If enabled, you will receive an alert each time a Shell Card Transaction occurs that is lower than the Minimum Mileage you have set.
                                                                </small>

                                                            </div>
                                                            :
                                                            <div></div>

                                                    }

                                                </Card.Body>
                                            </Card> */}
                                            <Card>
                                                <Card.Body>

                                                    <div className="border border-secondary rounded p-3">
                                                        <a onClick={this.deviatedRouteShowHelpValueChange}>
                                                            <FeatherIcon className="iconspacing pull-right" icon="help-circle" size="18" />
                                                        </a>
                                                        <strong>Off-Route <br /> Alert</strong>
                                                        <label className="switch">
                                                            <input type="checkbox" className="warning" onChange={this.RunningMileageChange} checked={this.state.runningMileageIsChecked} />
                                                            <span className="slider round" />
                                                        </label>
                                                        <div className="text-success ">
                                                            {/* <small>
                                                                Acceptable [Variance, Events] : {this.state.valueRunning}
                                                            </small> */}
                                                            &nbsp;
                                                        </div>
                                                    </div>

                                                    {
                                                        this.state.deviatedRouteShowHelp
                                                            ?
                                                            <div className="text-secondary text-justify" Selected Pointers>
                                                                <small>
                                                                    If enabled, you will receive an alert each time a Shell Card Transaction occurs at a Shell station other than the ones selected by you on the map below.
                                                                </small>

                                                            </div>
                                                            :
                                                            <div></div>

                                                    }

                                                </Card.Body>
                                            </Card>
                                            <Card>
                                                <Card.Body>


                                                    <div className="border border-secondary rounded p-3">
                                                        <a onClick={this.excessiveDailyFuelingAlertChange}>
                                                            <FeatherIcon className="iconspacing pull-right" icon="help-circle" size="18" />
                                                        </a>
                                                        <strong>Excessive Daily <br /> Fueling Alert in Ltrs</strong>
                                                        <label className="switch">
                                                            <input type="checkbox" className="warning" onChange={this.ExcessiveFuelingChange} checked={this.state.excessiveFuelingIsChecked} />
                                                            <span className="slider round" />
                                                        </label>
                                                        <div style={{fontWeight: '600', fontSize: '16px'}}>
                                                            
                                                                {
                                                                
                                                                this.state.valueExcessiveFueling
                                                                

                        
                      
                                                                }
                                                                 
                                                                   
                                                                  
                                                                
                                                            
                                                        </div>
                                                    </div>

                                                    {
                                                        this.state.excessiveDailyFuelingShowhelp
                                                            ?
                                                            <div className="text-secondary text-justify">
                                                                <small>
                                                                    If enabled, you will be alerted each time a card is swiped beyond the allowed daily limit in Ltrs.
                                                                </small>

                                                            </div>
                                                            :
                                                            <div></div>

                                                    }

                                                </Card.Body>
                                            </Card>

                                        </CardDeck>
                                    </div>


                                )}


                                {
                                currentStep === 3 && (
                                    <div>

                                        <div className="mt-4">
                                            <h6 className="ml-4">Select Medium to Receive Alerts</h6>
                                            <ReminderAlert
                                                parentPushAlertDataCallback={this.callbackfunction_PushAlert}
                                                parentSMSCallback={this.callbackfunction_SMSalert}
                                                parentEmailCallback={this.callbackfunction_Emailalert}
                                                IsPushAlert={this.state.IsPushAlert}
                                                IsSMSChecked={this.state.IsSMSChecked}
                                                IsEmailChecked={this.state.IsEmailChecked}
                                                parentPushAlertSMSCallback={this.SetSMSCheck}
                                                parentPushAlertEmailCallback={this.SetEmailCheck}
                                                // handleSubmit ={this.handleSubmit}
                                                // BindSMSAndEmailGrid = {this.BindSMSAndEmailGrid}
                                                DataAddUpdate = {this.DataAddUpdate}
                                                groupid={this.state.groupid}
                                                vrnId={this.state.vrnId}
                                                
                                                // SMSdata={this.state.SMSdata}
                                                // Emaildata={this.state.Emaildata}

                                            >


                                            </ReminderAlert>
                                      
                                            
                                        </div>
                                      
                                        
                                     

                                    
<Row className='mt-0'>

<div className="col-md-6 col-12">
                    {/* <h4 className="pull-left">SMS Details</h4> */}
                   


                    <AdvanceTableWithDeleteButton
                        parentDeletedObjectCallback={this.GetDeleteSelectedRecords_SMS}
                        data={this.state.SMSdata} columns={this.state.SMScolumns}
                    >
                    </AdvanceTableWithDeleteButton>
                </div>
                <div className="col-md-6 col-12">

                    {/* <h4 className="pull-left">Email Details</h4> */}
                 



                    <AdvanceTableWithDeleteButton
                        parentDeletedObjectCallback={this.GetDeleteSelectedRecords_Email}
                        data={this.state.Emaildata} columns={this.state.Emailcolumns}>
                    </AdvanceTableWithDeleteButton>

                </div>

</Row>

                                        {/* <div class="row"> */}
                                        <div className="d-flex align-items-center justify-content-center" style={{ height: 'calc(20vh - 20px)',paddingRight:"100px"}}>
                                            <button type="submit" className="btn btn-shell mr-1 mb-1 align-center" onClick={this.handleSubmit} > SAVE</button>
                                        </div>
                                        </div>
                                        

                                    // </div>

                                )}





                                {(this.state.runningMileageIsChecked && currentStep === 2) && <MapContainer parentOutletNameCallback={this.callbackfunction_SelectedOutlet} outlets={this.state.outlets} allSelectedOutlet={this.state.allSelectedOutlet} ></MapContainer>

                                }




                                <div >

                                    {this.state.currentStep != 0 &&

                                        <div class="pull-left"><Button className="btn-shell" variant="warning" onClick={this.onClickPrevious}>Previous</Button></div>
                                    }
                                    {this.state.currentStep != 3 &&

                                        <div class="pull-right"><Button className="btn-shell" variant="warning" onClick={this.onClickNext}>Next</Button></div>

                                    }
                                </div>
                              



                            </Card.Body>
                        </Card>
                    </CardDeck >
                </Container >
            </>

        );
    }
};

export default TestStepper